<template>
    <div>
        <transition name="fade">
            <div class="drawer-bg" v-if="isOpen" @click="toggleDrawer"></div>
        </transition>
        <div class="drawer-container">
            <div class="container">
                <div class="drawer">
                    <button @click="toggleDrawer" class="toggle-button" :class="{ 'is-open' : isOpen }">
                        <span>Learn more about our areas of study</span>

                        <svg xmlns="http://www.w3.org/2000/svg" width="26.903" height="15.854" viewBox="0 0 26.903 15.854" class="desktop-chevron">
                            <path id="Path_1705" data-name="Path 1705" d="M31.046,56.247l-2.121-2.121L42.657,40.393l13.17,13.17-2.121,2.121L42.657,44.636Z" transform="translate(-28.925 -40.393)" fill="#fff"/>
                        </svg>
                    </button>
                    <div class="drawer-list" :class="{  'showing' : isOpen, 'hiding' : !isOpen }">
                        <slot></slot>
                        <ul>
                            <li class="drawer-item" v-for="item in question.options" :key="item.title">
                                <span class="item-title">{{ item.title }}</span><span>{{ item.description }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Drawer',
    props: ['question'],
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggleDrawer() {
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style scoped>

.drawer {
    color: #fff;
    background: var(--c-red);
    padding: 1.5rem 1.5rem 0 1.5rem;
    border-radius: 10px 10px 0 0;
    /* max-width: 960px; */
    margin: 0 auto;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

.drawer-container {
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100%;
    z-index: 200;
    max-height: 80vh;
    padding: 0;
}

@media (min-width: none) {
    .drawer-container {
        padding: 0 2rem;
    }
}

.toggle-button {
    color: #fff;
    border: none;
    padding: 12px 1rem;
    background: none;
    appearance: none;
    font-size: 18px;
    cursor: pointer;
    background: var(--c-red-secondary);
    width: 100%;
    display: block;
    text-transform: uppercase;
    font-family: var(--font-pdf);
    font-weight: bold;
    text-align: center;
    border-radius: 10px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
}

.toggle-button svg {
    width: 16px;
    margin-bottom: 8px;
}

@media (min-width: 900px) {
    .toggle-button {
        text-align: left;
        flex-direction: row;
        justify-content: space-between;
        font-size: 24px;
    }

    .toggle-button svg {
        width: auto;
        margin-bottom: 0;
    }
}

.drawer-list {
    padding: 0 0 1rem;
    margin: 0;
    overflow-y: scroll;
    transition: height 0.25s ease;
}

.drawer-list.showing {
    height: 300px;
 }
.drawer-list.hiding {
    height: 0px;
 }

.drawer-list p {
    margin-bottom: 2rem;
}

.drawer-list ul {
    padding: 2rem 1rem 0;
    margin: 0;
}

@media (min-width: 900px) {
    .drawer-list.showing {
        height: 500px;
    }
}

.drawer-item {
    display: block;
    align-items: flex-end;
    font-size: 16px;
    list-style: none;
}

.drawer-item + .drawer-item {
    margin-top: 2rem;
}

.item-title {
    font-weight: bold;
    font-size: 20px;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    background: var(--c-red);
    position: relative;
}

@media (min-width: 1100px) {
    .drawer-item {
        display: flex;
    }
    .item-title {
        min-width: 40%;
        flex-basis: 40%;
        position: relative;
        margin-right: 10px;
    }
    .item-title:after {
        content: " ........................................................................................................";
        white-space: nowrap;
        font-weight: normal;
        margin-left: 10px;
        position: absolute;
    }
}


.desktop-chevron {
    transform: scale(1);
}
.is-open .desktop-chevron {
    transform: scale(-1);
}

.drawer-bg {
    background: #000;
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 150;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
